import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Hooks } from '@grandvisionhq/carts-v2';
import { PackageQuantityDropdownView, ProductDetailActions } from '@grandvisionhq/fun-products';
import { useProductDetailContext } from '../../Context/ProductDetailContext.js';

var PackageQuantityDropdownContainer = (_param)=>{
    var { onChange  } = _param, props = swcHelpers.objectWithoutProperties(_param, [
        "onChange"
    ]);
    const { dispatch , productType , product  } = useProductDetailContext();
    const formatter = Hooks.useGetProductLinkFormatter();
    const handleChange = (item)=>{
        const productLink = formatter(product.slug, item.value, productType);
        dispatch(ProductDetailActions.updateActiveVariant({
            sku: item.value
        }));
        window.history.replaceState(null, '', productLink);
        onChange(item);
    };
    return /*#__PURE__*/ React.createElement(PackageQuantityDropdownView, swcHelpers.extends({}, props, {
        onChange: handleChange
    }));
};

export { PackageQuantityDropdownContainer };
//# sourceMappingURL=PackageQuantityDropdownContainer.js.map
